<div class="redaction-step-edit-dialog">
    <!-- Header -->
    <div class="dialog-header">
        <h2 mat-dialog-title>
            <mat-icon>{{ data.mode === 'edit' ? 'edit' : 'add_circle' }}</mat-icon>
            {{ data.mode === 'edit' ? 'Editare Pas Redactare' : 'Adaugă Pas Redactare Nou' }}
        </h2>
        <button mat-icon-button (click)="onCancel()" class="close-btn">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Content -->
    <mat-dialog-content>
        <form [formGroup]="form" class="edit-form">
            <!-- Tip Redactare -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Tip Redactare</mat-label>
                    <mat-select formControlName="redaction_type" required>
                        <mat-option *ngFor="let type of redactionTypes" [value]="type.value">
                            <mat-icon class="type-icon">{{ type.icon }}</mat-icon>
                            {{ type.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Funcție -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Funcția (Tip Utilizator)</mat-label>
                    <mat-select formControlName="user_type">
                        <!-- Search input -->
                        <mat-form-field class="search-field">
                            <input matInput
                                   [formControl]="functieSearchCtrl"
                                   placeholder="Caută funcție..."
                                   (keydown)="onSearchKeydown($event)"
                                   (click)="onSearchClick($event)">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>

                        <mat-option [value]="null">-- Nicio funcție specificată --</mat-option>
                        <mat-option *ngFor="let functie of filteredFunctii" [value]="functie.id">
                            {{ functie.name }}
                            <span *ngIf="functie.acronym" class="acronym">({{ functie.acronym }})</span>
                        </mat-option>
                    </mat-select>
                    <mat-hint>Funcția/rolul utilizatorului care va procesa acest pas</mat-hint>
                </mat-form-field>
            </div>

            <!-- Direcție -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Direcția</mat-label>
                    <mat-select formControlName="directie_id">
                        <!-- Search input -->
                        <mat-form-field class="search-field">
                            <input matInput
                                   [formControl]="directieSearchCtrl"
                                   placeholder="Caută direcție..."
                                   (keydown)="onSearchKeydown($event)"
                                   (click)="onSearchClick($event)">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>

                        <mat-option [value]="null">-- Nicio direcție specificată --</mat-option>
                        <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id_directie">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Direcția din care face parte utilizatorul</mat-hint>
                </mat-form-field>
            </div>

            <!-- Compartiment -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Compartimentul</mat-label>
                    <mat-select formControlName="compartiment_id" [disabled]="!form.get('directie_id')?.value">
                        <!-- Search input -->
                        <mat-form-field class="search-field">
                            <input matInput
                                   [formControl]="compartimentSearchCtrl"
                                   placeholder="Caută compartiment..."
                                   (keydown)="onSearchKeydown($event)"
                                   (click)="onSearchClick($event)">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>

                        <mat-option *ngIf="loadingCompartimente" disabled>
                            <mat-spinner diameter="20"></mat-spinner>
                            Se încarcă...
                        </mat-option>
                        <mat-option [value]="null">-- Niciun compartiment specificat --</mat-option>
                        <mat-option *ngFor="let comp of filteredCompartimente" [value]="comp.id_compartiment">
                            {{ comp.name }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Selectați mai întâi o direcție</mat-hint>
                </mat-form-field>
            </div>

            <!-- Operator Specific -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Operator Specific (opțional)</mat-label>
                    <mat-select formControlName="specific_user_id"
                                [disabled]="!form.get('compartiment_id')?.value">
                        <!-- Search input -->
                        <mat-form-field class="search-field">
                            <input matInput
                                   [formControl]="userSearchCtrl"
                                   placeholder="Caută utilizator..."
                                   (keydown)="onSearchKeydown($event)"
                                   (click)="onSearchClick($event)">
                            <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>

                        <mat-option *ngIf="loadingUsers" disabled>
                            <mat-spinner diameter="20"></mat-spinner>
                            Se încarcă...
                        </mat-option>
                        <mat-option [value]="null">-- Niciun utilizator specific --</mat-option>
                        <mat-option *ngFor="let user of filteredUsers" [value]="user.id_user || user.id">
                            {{ user.full_name || user.name }}
                        </mat-option>
                    </mat-select>
                    <mat-hint>Dacă este setat, doar acest utilizator poate procesa pasul</mat-hint>
                </mat-form-field>
            </div>

            <!-- Descriere -->
            <div class="form-row">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Descriere (opțional)</mat-label>
                    <textarea matInput formControlName="description" rows="2"
                              placeholder="Descriere scurtă a pasului de redactare..."></textarea>
                    <mat-hint>O descriere opțională a ce trebuie făcut în acest pas</mat-hint>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>

    <!-- Actions -->
    <mat-dialog-actions align="end">
        <button mat-button (click)="onCancel()" [disabled]="saving">
            Anulează
        </button>
        <button mat-raised-button color="primary"
                (click)="onSubmit()"
                [disabled]="saving || form.invalid">
            <mat-icon *ngIf="saving">
                <mat-spinner diameter="18"></mat-spinner>
            </mat-icon>
            <mat-icon *ngIf="!saving">{{ data.mode === 'edit' ? 'save' : 'add' }}</mat-icon>
            {{ saving ? 'Se salvează...' : (data.mode === 'edit' ? 'Salvează' : 'Adaugă') }}
        </button>
    </mat-dialog-actions>
</div>
